import { render } from "./modal-next.vue?vue&type=template&id=830e56a2"
import script from "./modal-next.vue?vue&type=script&lang=js"
export * from "./modal-next.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./modal-next.vue?vue&type=style&index=0&id=830e56a2&lang=less&module=true"
cssModules["$style"] = style0
/* custom blocks */
import block0 from "./modal-next.vue?vue&type=custom&index=0&blockType=i18n&lang=json"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__